import "./App.css";
import { Route, Routes } from "react-router-dom";
import React from "react";
import CargarArchivos from "./components/CargarArchivos";
import ListaDeArchivos from "./components/ListaDeArchivos";
import ListaFormatos from "./components/ListaFormatos";
import { AccessTokenProvider } from './AccessTokenProvider';

function App() {
  return (
      <Routes>
      <Route path="/" element={<CargarArchivos />} />
      <Route path="ListaDeArchivos" element={<ListaDeArchivos />} />
      <Route path="ListaFormatos" element={<ListaFormatos />} />
      </Routes>
     
  );
}


export default App;
